import { render } from "./CustomSliderImage.vue?vue&type=template&id=53564112&scoped=true"
import script from "./CustomSliderImage.vue?vue&type=script&lang=js"
export * from "./CustomSliderImage.vue?vue&type=script&lang=js"

import "./CustomSliderImage.vue?vue&type=style&index=0&id=53564112&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53564112"]])

export default __exports__